"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = toggle;
/**
 * Provides a default implementation to toggle a property. Many UI actions revolve
 * around toggling state.
 *
 * @param {Object} scope Scope of the method to work on.
 * @param {String} property Property that keeps the dropdown state.
 * @param {Function} callback Optional callback to use for both toggle states.
 * @returns {Function} event handler that switched state.
 * @api private
 */
function toggle(scope) {
  let property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dropdown';
  let callback = arguments.length > 2 ? arguments[2] : undefined;
  if (arguments.length === 2 && typeof property === 'function') {
    callback = property;
    property = 'dropdown';
  }
  return function (event, done) {
    const state = scope.state || {};
    done = done || callback;
    if (typeof done !== 'function') {
      done = null;
    }
    scope.setState({
      [property]: !state[property]
    }, done);
  };
}